<template>
  <ShowControl  @revert="revertClick"  :title="title" ref="showControl">
    <div style="width: 90%;margin-top: 2%;" >
    <div style="height: 100%;" >
      <el-table :data="EnterpriseList"
                style="width: 100%;height: 85%;"
                v-loading="loadings">
        <el-table-column prop="compCh"
                         label="企业名称"
                         align="center"></el-table-column>
        <el-table-column prop="jyfw1"
                         show-overflow-tooltip
                         label="企业概况"
                         align="center"></el-table-column>
        <el-table-column prop="companyType"
                         label="企业类型"
                         align="center">
          <template #default="scope">
            <div v-if="scope.row.isFaucet==0">
              <span v-if="scope.row.companyType==Global.EnterpriseType.large">
                大型企业
              </span>
              <span v-if="scope.row.companyType==Global.EnterpriseType.medium">
                中型企业
              </span>
              <span v-if="scope.row.companyType==Global.EnterpriseType.small">
                小型企业
              </span>
            </div>
            <div v-if="scope.row.isFaucet==1">
              <span>龙头企业</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="cost"
                         show-overflow-tooltip
                         label="成本"
                         align="center">
          <template #default="scope">
            <span> {{String(scope.row.cost).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}元</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="CompanyInput.CurrentPage"
                     :page-sizes="[5,10, 15, 20]"
                     :page-size="CompanyInput.Pagesize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="EnterpriseTotal"
                     style="margin-top: 15px; display: flex; justify-content: center;">
      </el-pagination>
    </div>
    </div>
  </ShowControl>
</template>

<script>
import { mapState } from "vuex";
import ShowControl from "../../UserControl/ShowControl.vue"
export default {
    props: ["datas"], 
  components: {
    ShowControl
  },
  data () {
    return {
      flowID: localStorage.getItem("flowID"),
      EnterpriseTypeList: [],
      EnterpriseTypeTotal: 0,
      currentPage: 1,
      pagesize: 5,
      Enterprise: false,
      EnterpriseList: [],
      EnterpriseTotal: '',
      loading: false,
      EnterpriseTypeId: 0,
      loadings: false,
      CompanyInput:
      {
        CompanyTypeId: "",
        CurrentPage: 1,
        Pagesize: 10,
        Query: ""
      },
      CompanyTypeInput:
      {
        round: null,
        currentPage: 1,
        pagesize: 5,
        companyIds: ""
      },
      Search:
      {
        industryId:null
      },
      ExhibitionIndustryList:[],
      title: '营销数据管理',
    }
  },
  computed: {
    ...mapState({
      Round: (state) => state.user.round,
    }),
  },
  created () {
    this.Check(this.$route.query.id)
  },
  mounted(){
    this.$refs.showControl.receiveValue(true);
  },
  methods: {
    revertClick(){
      this.$router.push("/MarketingDataManagementCard")
    },
    handleSizeChange: function (size) {
      this.CompanyInput.Pagesize = size;
      this.Check();
    },
    handleCurrentChange: function (currentPage) {
      this.CompanyInput.CurrentPage = currentPage;
      this.Check();
    },
    Check (id) {
      this.childTitle = '企业类型列表'
      if (id != undefined) {
        this.CompanyInput.CompanyTypeId = id.toString();
      }
      this.loadings = true;
      this.$http.post(`Company/GetCompanyLsit`, this.CompanyInput).then((res) => {
        if (res.success) {
          this.EnterpriseList = res.dynamicObj;
          this.EnterpriseTotal = res.totalRecord;
          this.loadings = false
        } else {
          return this.$message.error(res.message)
        }
      })
    }
  }
}
</script>